import { restClient } from '@/Core'

import { DISK_ADMIN_API } from './diskAdminApi'

import type { DiskPolicy } from '../Contracts/DiskAdmin'

/** Політика диска тенанта: `GET /services/disk/admin/policy` — значення, дефолти, ліміт тенанта. */
export const LoadDiskPolicyTask = async (): Promise<DiskPolicy> =>
    (await restClient.get(`${DISK_ADMIN_API}/policy`, {}, { forceRefresh: true })) as unknown as DiskPolicy
